<template>
    <div>
        <headersite></headersite>
        <main id="main">
            <subheader></subheader>
            <KeepAlive>
                <router-view></router-view>
            </KeepAlive>
        </main>

        <verticalnavbar></verticalnavbar>
        <footersite></footersite>
    </div>
</template>

<script>
export default {};
</script>
